import { toast } from 'react-toastify';

// Errors stay up long enough to read (and while the pointer rests on them);
// a confirmation can go sooner. Both close on click.
export const ShowToastMessage = (errorOrSuccess, message) => {
    errorOrSuccess === "error" ? toast.error(message, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    }) : toast.success(message, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 2500,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
    })
}
